export default __webpack_public_path__ + "static/media/ScholarCourseImage1.3525761a.svg";